import Loading from "@/component/Loading";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { useQuery } from "react-query";
import { publicApi } from "@/utils/util";
import { VodPlay } from "./Curriculum";
import { webviewPostMessage, isWebview } from "@/utils/webviewUtil";
import { getStaticImgUrl } from "@/utils/imageUtil";
import { createPortal } from "react-dom";

const LectureVideo = ({
  courseId,
  chapterId,
  lectureId,
  setPopup,
  bookmark,
  progressPercent,
}: {
  courseId: string;
  chapterId: string;
  lectureId: string;
  setPopup: Dispatch<SetStateAction<VodPlay>>;
  bookmark: number;
  progressPercent?: number;
}) => {
  const [kollusLink, setKollusLink] = useState<string>("");

  const { data, isLoading } = useQuery(
    ["classCoursesChaptersLectures"],
    () =>
      publicApi
        ?.get(
          !bookmark && progressPercent && progressPercent > 0
            ? `/class/courses/${courseId}/chapters/${chapterId}/lectures/${lectureId}/video?useIntroOutro=true`
            : `/class/courses/${courseId}/chapters/${chapterId}/lectures/${lectureId}/video`,
        )
        .then((res) => res.data),
    {
      enabled: !!(chapterId && lectureId),
      onSuccess: (data) => {
        let link = data.url.replace("http", "https");
        // 신규 Web Player(v5). 보안(v3)/비보안(v4) 통합 버전으로 macOS 에서는
        // Mac 전용 플레이어 대신 브라우저 내 Agent 방식으로 재생된다.
        // 플레이어 버전을 지정하는 같은 축이므로 pc_player_version 을 대체한다.
        link = [link, "pv=v5", bookmark ? `s=${bookmark}` : ""].join("&");
        setKollusLink(link);
      },
    },
  );

  useEffect(() => {
    const lectureVideo = document.getElementById("lecture_video");
    if (!lectureVideo || !kollusLink) return;
    try {
      const controller = new (window as any).VgControllerClient({
        target_window: (lectureVideo as any).contentWindow,
      });
      console.log(controller);
      controller.on("play", function () {
        console.log("play");
      });
    } catch (e) {
      alert(e);
    }
  }, [kollusLink]);

  const openMobileKollus = () => {
    // 모바일(앱) 대응 코드입니다.
    if (!kollusLink) {
      setTimeout(() => {
        openMobileKollus();
      }, 1000);
    }
    let url = "kollus://path?url=" + encodeURIComponent(kollusLink);
    url = url.replace("kollus.com%2Fs", "kollus.com%2Fsi");
    const body = {
      kollus: url,
      ios: "itms-apps://itunes.apple.com/app/id760006888",
      android: "market://details?id=com.kollus.media",
    };

    return webviewPostMessage("openKollus", body);
  };

  if (!data && isLoading) return <Loading />;

  return createPortal(
    <>
      <div className="relative">
        <div
          className="fixed left-0 right-0 top-0 bottom-0 z-[100] bg-[rgba(0,0,0,0.4)]"
          onClick={() => setPopup({ popup: false, bookmark: 0, lectureId: "" })}
        ></div>
        {isWebview() && (
          <button
            className="fixed z-[120] top-[50%] left-[50%] -translate-x-1/2 -translate-y-1/2 w-5/6 h-[230px] rounded-lg"
            onClick={openMobileKollus}
          ></button>
        )}

        <div className="fixed z-[110] top-[50%] left-[50%] -translate-x-1/2 -translate-y-1/2 bg-[#fff] lg:w-[585px] lg:h-[424px] w-5/6 h-auto rounded-lg">
          <img src={getStaticImgUrl("klass/player-frame-mo.png")} alt="" className="lg:hidden" />
          <img
            src={getStaticImgUrl("klass/player-frame-pc.png")}
            alt=""
            className="hidden lg:block"
          />
          <div className="absolute top-[40%] lg:top-[25%] left-[10%] lg:left-[18%] w-[80%] h-[40%] lg:w-[64%] lg:h-[60%] overflow-hidden flex items-center justify-center">
            <iframe
              src={kollusLink}
              id="lecture_video"
              title="lecture"
              allowFullScreen
              className="w-full h-full"
              allow="encrypted-media;local-network-access"
            ></iframe>
          </div>

          <div
            className="absolute top-3 right-3"
            onClick={() => setPopup({ popup: false, bookmark: 0, lectureId: "" })}
          >
            <i className="ii-remove ii-weight-600 text-2xl text-secondary-800 cursor-pointer"></i>
          </div>
        </div>
      </div>
    </>,
    document.body,
  );
};

export default LectureVideo;
